'use strict';
var arrayUniq = require('array-uniq');

module.exports = function () {
	return arrayUniq([].concat.apply([], arguments));
};



//////////////////
// WEBPACK FOOTER
// ./~/array-union/index.js
// module id = 552
// module chunks = 0